export const videoFunctionFeatureTranslationJP = {
  videoFunction: {
    title: '動画再生設定',
    hint: '※並び順の変更について',
    hint_1: '動画を選択して、キーボード操作で並び順を変更することができます。',
    filter: {
      title: '絞り込み',
      title_selection: '削除データ',
      show_valid: '削除データ非表示',
      show_all: '削除データ含めて表示',
      show_deleted: '削除データのみ表示',
      narrow_down: '絞り込み',
    },
    button: {
      add: '新規追加',
      edit: '詳細',
      delete: '削除',
      save: '保存',
    },
    no_data_changed: 'データは変更されていません',
    warn_confirm_delete: '選択された動画再生を削除します。よろしいですか？',
    warning_save_data: 'データが変更されました。<br/>データを保存しますか。',
    success_delete: 'データを削除しました',
    success_restore: '削除データを復元しました',
    sucesss_save: '保存しました',
  },
  videoFunctionListPage: {
    choice: '選択',
    video_name: '動画名',
    remarks: '備考',
    restore: '復元',
  },
  videoFunctionDetailModal: {
    title: '動画再生詳細',
    button: {
      save: '保存',
    },
    video_name: '名称',
    display_name: {
      title: 'タイトル',
      jp: '日本語',
      en: '英語',
      cns: '中国語（簡体字）',
      cnt: '中国語（繁体字）',
      ko: '韓国語',
      vi: 'ベトナム語',
    },
    thumbnail_img: 'サムネイル画像',
    video: '動画',
    note: '備考',
    warn_field_required: 'この項目は必須です',
  },
};
